var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.area = function (widget, chart, data, metadata) {
    if (!data || data.length === 0) {
        widget.find('.loading-box').hide();
        return;
    }

    var debugWidget = widget.data('id') === '3946b9b1-cfd0-4311-9a15-ee8c059fc807';
    
    setTimeout(function () {
        MDB.Charts.emptyChartAndMakeVisible(widget, chart);

        var useLegacyKeyTransform = metadata && metadata.KendoConfig && metadata.KendoConfig._UseLegacyKeyTransformation;
        var keyMappings = MDB.Charts.transformKeysToKendoFields(data, useLegacyKeyTransform);
        var aliasses = MDB.Charts.getColumnAliasses(widget);
        
        var container = $('<div class="barsAndLines">').css({ width: '90%', height: '90%', top: '5%', left: '5%' });
        var axisData = data[0];
        var keys = MDB.Charts.getDataKeys(axisData);

        var kendoConfig = {
            dataSource: {
                data: data
            },
            categoryAxis: {
                field: keyMappings[0].field,
                type: metadata.ColumnTypes[keyMappings[0].originalKey],
                baseUnit: 'fit',
                baseUnitStep: 'auto',
                labels: {
                    rotation: -45
                }
            },
            seriesDefaults: {
                type: "area",
                stack: true
            },
            valueAxis: {
                line: {
                    visible: true
                },
                axisCrossingValue: -10,
                max: 100
            },
            series: keys.slice(1).reduce(function (result, key) {
                var keyMapping = keyMappings.findByKey(key) || {key: key, originalKey: key};

                result.push({
                    name: aliasses[keyMapping.originalKey],
                    field: keyMapping.field
                });
                return result;
            }, [])
        };
        
        if (kendoConfig.categoryAxis.type === 'date'){
            //Prevent format from being overridden
            kendoConfig.categoryAxis.labels.format = kendoConfig.categoryAxis.labels.format || '';
            MDB.Charts.setCategoryAxisWeekDisplayToWeekNumbers(kendoConfig);
        } 

        
        $.extend(true, kendoConfig, metadata.KendoConfig);

        var getGlobalDataString;
        var formatableValues = getFormatableValues(undefined, function (globalDataString) {
            getGlobalDataString = globalDataString;
        });
        
        _.each(kendoConfig.series, function (serie) {
            MDB.Charts.setLabelFormat(serie, kendoConfig.seriesDefaults, function () {
                return formatableValues 
            }, undefined, undefined, function (target, template) {
                if (getGlobalDataString){
                    return '# if(' + getGlobalDataString + ') { # ' + template + ' # } # ';
                }
  
                return template;
            });

            MDB.Charts.setLabelFormat(serie, kendoConfig.seriesDefaults, function () {
                return formatableValues 
            }, undefined, 'tooltip', function (target, template) {
                template = template || sprintf('#= kendo.format(\'%s\', value) #', target.format || '{0}');
                return MDB.Charts.combineWithDefaultTooltipTemplate(template, target);
            });
        });
        
        MDB.Charts.initializeLegendClickHandler(kendoConfig, function (visibleSeries) {
            getFormatableValues(visibleSeries, function (globalDataString) {
                getGlobalDataString = globalDataString;
            });
        });

        chart.height(MDB.Charts.calculateKendoChartMaxHeight(widget)).append(container);
        container.kendoChart(kendoConfig);
        
        function getFormatableValues(visibleSeries, setGlobalDataString) {
            var visibleData = data;

            if (visibleSeries){
                var visibleFields = _.map(visibleSeries, 'field');

                visibleData = _.map(visibleData, function(dataItem){
                    return _.pick(dataItem, visibleFields);
                });
            }

            var formatableValues = MDB.Charts.getAggregatedFormatableValues(visibleData, keys);
            
            if (kendoConfig.axisDefaults.labels){
                var conditionalDisplay = kendoConfig.axisDefaults.labels.conditionalDisplay;
                kendoConfig.axisDefaults.labels = undefined;

                //Labels displayed on the side, outside of the chart, these should never be hidden
                MDB.Charts.setLabelFormat(kendoConfig.axisDefaults,  kendoConfig.axisDefaults, formatableValues, '__TOTALS__');

                kendoConfig.axisDefaults.labels = conditionalDisplay;
            }

            var defaultFormatableValues = formatableValues;

            var getItemFormatableValue = function (formatType, args) {
                if (formatType === 'percentageTotal') {
                    return _.sum(_.map(args.series.data, args.series.field));
                }

                return defaultFormatableValues.valueFor(args.series.field, formatType);
            };

            var globalDataKey = MDB.Charts.registerGlobalData(getItemFormatableValue, widget.data('id'));

            //Only the valueFor function is actually used, override it with our own and return our global data value
            return {
                valueFor: function (field, formatType) {
                    var getGlobalDataString = undefined;

                    //Verify whether we can actually return a valid value
                    if (formatableValues.valueFor(field,  formatType)){
                        getGlobalDataString = sprintf('MDB.Charts.getGlobalData(\'%s\')(\'%s\', arguments[0])', globalDataKey, formatType);
                    }

                    setGlobalDataString(getGlobalDataString);
                    return getGlobalDataString;
                },
                valueForItem: function(field, formatType, args) {
                    if (defaultFormatableValues.valueFor(field, formatType) && args) {
                        return getItemFormatableValue(formatType, args);
                    }

                    return undefined;
                }
            };
        }
    }, 0);
};